export default __webpack_public_path__ + "static/media/SpaceandPeopleLogo.4edbe8e2.png";